export default __webpack_public_path__ + "static/media/suunto_logo_white.fe1bbd52.svg";